import {
    GET_REPORT_CURRENCY_REQUEST,
    GET_REPORT_CURRENCY_SUCCESS,
    GET_REPORT_CURRENCY_ERROR,

}from "../../actions/types";
  
  export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
      case GET_REPORT_CURRENCY_REQUEST:
        return {
          loading: true,
        };
      case GET_REPORT_CURRENCY_SUCCESS:
        return {
          ...state,
          loading: false,
          payload,
        };
      case GET_REPORT_CURRENCY_ERROR:
        return {
          ...state,
          loading: false,
          payload,
        };

      default:
        return state;
    }
  }
  